module.exports = __webpack_public_path__ + "img/privilege.7893816c.png";